import { render, staticRenderFns } from "./AccomodationsValues.vue?vue&type=template&id=3ca857ba&scoped=true&"
import script from "./AccomodationsValues.vue?vue&type=script&lang=js&"
export * from "./AccomodationsValues.vue?vue&type=script&lang=js&"
import style0 from "./AccomodationsValues.vue?vue&type=style&index=0&id=3ca857ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca857ba",
  null
  
)

export default component.exports